import AnesthetistQuestionaryFormContainer from "./AnesthetistSignatureFormContainer";

export default AnesthetistQuestionaryFormContainer;
